import {
    Component,
    ElementRef,
    EventEmitter,
    Injector,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { AutocompleteSettingsModel } from './autocomplete-settings.model';
import { isDefined } from '@fi-shared/utils';

@Component({
    selector: 'fi-autocomplete',
    templateUrl: './autocomplete.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./autocomplete.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: AutocompleteComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: AutocompleteComponent,
            multi: true,
        },
    ],
    host: { class: 'fi-autocomplete' },
    standalone: false,
})
export class AutocompleteComponent extends ControlValueAccessorValidatorBase<string> implements OnInit, OnChanges {
    @Input() autocompleteSettings: AutocompleteSettingsModel = new AutocompleteSettingsModel();
    @Input() required: boolean;
    @Input() autoFocus: boolean;
    @Input() tabIndex: number;
    @Input() autocompleteData: any[];
    @Output() onPressEnter = new EventEmitter<Event>();
    @Output() onSelect = new EventEmitter<any>();

    @ViewChild('inputElement') inputElementRef: ElementRef;
    selectedItemNames: string = '';

    SelectedItemsMap: {
        [prop: string]: any;
    };

    constructor(private injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes.autocompleteData;
        if (change && !change.firstChange) {
            if (change.currentValue) {
                this.updateDataSet(change.currentValue);
            }
        }
    }

    ngOnInit() {
        if (!this.ngModel) {
            this.ngModel = '';
            this.doPropagateChanges();
        }

        if (this.autocompleteData) {
            this.updateDataSet(this.autocompleteData);
        }

        this.initialize();
    }

    validate(c: AbstractControl): ValidationErrors {
        if (this.required && !this.ngModel) {
            return {
                required: true,
            };
        }
        return null;
    }

    private getFirstSelectedItem(itemValue) {
        for (let i = 0; i < this.autocompleteSettings.Groups.length; i++) {
            let item = this.autocompleteSettings.Groups[i].DataSet.find(
                (item) => item[this.autocompleteSettings.DataValueField] === itemValue,
            );
            if (item) {
                return item;
            }
        }
    }

    private updateDataSet(newDataSet: any[]) {
        this.autocompleteSettings.DataSet = newDataSet;
        if (this.autocompleteSettings.Groups.length > 0 && !this.autocompleteSettings.Groups[0].title) {
            this.initializeSelectedItems();
            this.updateSelectedItems();
        }
    }

    //Store selected items in the dictionary for fast access
    private initializeSelectedItems() {
        this.SelectedItemsMap = {};
        this.SelectedItemsMap[this.ngModel] = this.getFirstSelectedItem(this.ngModel);
    }

    private updateSelectedItems() {
        let names: string[] = [];
        for (let i in this.SelectedItemsMap) {
            if (this.SelectedItemsMap[i] != null) {
                let item = this.SelectedItemsMap[i];
                names.push(
                    item[this.autocompleteSettings.SelectedTextField] || item[this.autocompleteSettings.DataTextField],
                );
            } else {
                delete this.SelectedItemsMap[i];
            }
        }

        this.selectedItemNames = names.join(', ').length
            ? names.join(', ')
            : (this.selectedItemNames = this.autocompleteSettings.Localization.NoSelectedItems);
    }

    selectItem(item) {
        let value = item[this.autocompleteSettings.DataValueField];

        this.SelectedItemsMap = {};
        this.SelectedItemsMap[value] = item;

        this.onSelect.emit(item);

        this.updateSelectedItems();

        this.ngModel = this.SelectedItemsMap[value] ? value : undefined;
        this.doPropagateChanges();
    }

    initialize() {
        this.initializeSelectedItems();
        this.updateSelectedItems();
    }

    focusInput() {
        this.inputElementRef.nativeElement.focus();
    }

    /*
        Search(item) { //todo implement search?
            //Filter on multiple properties
            if (this.dropdownSettings.FilterBy && this.dropdownSettings.FilterBy instanceof Array) {
                for (var i = 0; i < this.dropdownSettings.FilterBy.length; i++) {
                    if (GetPropertyByString(item, this.dropdownSettings.FilterBy[i]).toLowerCase().indexOf(this.ngModel.toLowerCase()) != -1) {
                        return true;
                    }
                }
            }
            //Filter on 1 property
            else if (this.dropdownSettings.FilterBy) {
                if (GetPropertyByString(item, this.dropdownSettings.FilterBy)) {
                    return GetPropertyByString(item, this.dropdownSettings.FilterBy).toLowerCase().indexOf(this.ngModel.toLowerCase()) != -1;
                }

                return false;
            }
            //Filter all properties
            else {
                return $filter('filter')([item], this.ngModel, this.dropdownSettings.FilterBy ? this.dropdownSettings.FilterBy : "$").length > 0; todo
            }
        };

        SearchGroup(group) {
            return $filter('filter')(group.DataSet, this.ngModel, this.dropdownSettings.FilterBy ? this.dropdownSettings.FilterBy : "$").length > 0; todo
        };
    */
}
